import React from "react";
import {
  GroupsSectionData,
  SignalsGroupsType,
} from "@shared/features/onboarding/types";

export const GroupsPageContext = React.createContext<
  | {
      myGroupsData: GroupsSectionData;
      freeTrialGroupsData: GroupsSectionData;
      freeGroupsData: GroupsSectionData;
      personalGroupsData: GroupsSectionData;
      isGroupsPage?: boolean;
      noExternalAccountConnected?: boolean;
      groupIdToNumBots: Record<number, number>;
      refetch: (groupType: SignalsGroupsType) => void;
    }
  | undefined
>(undefined);
